module.exports = __webpack_public_path__ + "static/the-classic-treasury-of-aesops-fables-c47ee3d38f48ddb7d0cf2a69f6099342.jpg";